<script setup lang="ts">
    interface MemberHighlightProps {
        data: MemberHighlightData;
    }

    const props = defineProps<MemberHighlightProps>();
</script>
<template>
    <mol-section
        class="mol-member-highlight"
        :background-image="data.style.background_image"
        :background-image-mobile="data.style.background_image_mobile">
        <atm-container
            width="content"
            class="relative z-1 py-10 md:py-20">
            <atm-account-card>
                <div class="flex flex-col gap-3 text-center">
                    <atm-heading
                        :font-bold="false"
                        size="3xl"
                        class="heading-member">
                        {{ data.title }}
                    </atm-heading>
                    <span class="flex flex-col gap-1 text-balance">
                        <atm-heading
                            level="span"
                            size="lg">
                            {{ data.subtitle }}
                        </atm-heading>
                        <p>{{ data.description }}</p>
                    </span>
                </div>
            </atm-account-card>
        </atm-container>
    </mol-section>
</template>
